import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseIcon from '@material-ui/icons/Close';
import SharedAdminDrawer, { DRAWER_WIDTH_XL, DRAWER_WIDTH_LG, DRAWER_WIDTH_MD, DRAWER_WIDTH_SM } from './SharedAdminDrawer';
import { useSelector, useDispatch } from "react-redux"
import * as AuthActions from "../../store/actions/auth";
import SharedAppBar from './SharedAppBar';
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Card, CardActions, CardContent, Tabs, Tab } from '@material-ui/core';
import ClinicDetails from "./clinicDetails";
import ClinicSettings from "./clinicSettings";
import ClinicSecurity from "./clinicSecurity";
import ClinicSubscription_Settings from "./clinicSubscription_Settings";
import HealingIcon from '@material-ui/icons/Healing';
import ChatSystemContainer from '../../components/ChatSystem/ChatSystemContainer';
import MessageNotification from '../../components/MessageNotification';
import useClinicianAuthGuard from './useClinicianAuthGuard';
import VideoCallLauncherDialog from './VideoCallLauncherDialog';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  avatar: {
    backgroundColor: '#00e676',
    height: 50,
    width: 50
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingBottom: 7,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 57,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.down('xs')]: {
      height: 50,
    },
    [theme.breakpoints.up('sm')]: {
      height: 57,
    },
    [theme.breakpoints.up('md')]: {
      height: 57,
    },
    [theme.breakpoints.up('lg')]: {
      height: 57,
    },
    [theme.breakpoints.up('xl')]: {
      height: 57,
    },
  },
  responsiveLogo: {
    marginTop: 8,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 180,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 190,
      minWidth: 165,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  tabs: {
    backgroundColor: '#f7faff',
    borderRadius: 12,
    marginBottom: '0.6%',
    height: 'clamp(24px, calc(4px + 4.5vw), 44px)',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,45,85,0.12)',
    [theme.breakpoints.only('md')]: {
      height: 'clamp(24px, calc(4px + 4.5vw), 38px)',
    },
  },
  tabsControlRoot: {
    minHeight: 'clamp(24px, calc(4px + 4.5vw), 44px)',
    height: 'clamp(24px, calc(4px + 4.5vw), 44px)',
    '& .MuiTabs-flexContainer': {
      height: '100%',
      alignItems: 'center',
    },
    [theme.breakpoints.only('md')]: {
      minHeight: 'clamp(24px, calc(4px + 4.5vw), 38px)',
      height: 'clamp(24px, calc(4px + 4.5vw), 38px)',
    },
  },
  tab: {
    fontWeight: 600,
    fontSize: 'clamp(0.75rem, 1.04vw, 0.95rem)',
    textTransform: 'uppercase',
    color: '#002D55',
    minWidth: 'clamp(60px, 6.9vw, 100px)',
    padding: '0 clamp(4px, 0.7vw, 12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '&.Mui-selected': {
      color: '#002D55',
    },
    '&:hover': {
      color: '#FF7F27',
    },
  },
  tabIndicator: {
    backgroundColor: '#FF7F27',
    height: 3,
    borderRadius: 18,
    bottom: 0,
  },
}));

export default function MyClinicAccount() {
  const { isAuthorizedClinician } = useClinicianAuthGuard();
  const token = useSelector(state => state.auth.token);
  const [webcamDialogOpen, setWebcamDialogOpen] = useState(false);
  const handleOpenWebcamDialog = () => setWebcamDialogOpen(true);
  const handleCloseWebcamDialog = () => setWebcamDialogOpen(false);
  
  // Tab state
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => setTabValue(newValue);
  
  // Notification state
  const [notification, setNotification] = useState(null);

  const classes = useStyles();
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const activeDrawerWidth = isSm ? DRAWER_WIDTH_SM : isMd ? DRAWER_WIDTH_MD : isXl ? DRAWER_WIDTH_XL : DRAWER_WIDTH_LG;
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

 // const user = {
 //   avatar: '/static/images/avatars/avatar_6.png',
 //   city: 'Los Angeles',
 //   country: 'USA',
 //   jobTitle: 'Senior Developer',
 //   name: 'Katarina Smith',
 //   timezone: 'GTM-7'
 // };


  const Profile = ({ className, ...rest }) => {
    const classes = useStyles();

    return (
      <Card
      className={classes.root}
      >
      
    </Card>
    );
  };

  Profile.propTypes = {
    className: PropTypes.string
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  if (!isAuthorizedClinician || !token) {
    return <div>Redirecting...</div>;
  }

  return (
    <div className={`${classes.root} admin-dash`}>
      <CssBaseline />
      <MessageNotification message={notification} />
      {/* <SharedAppBar 
        open={open} 
        drawerWidth={activeDrawerWidth}
        showMessages={true} 
        showVideocall={true} 
        onVideocallClick={handleOpenWebcamDialog}
      /> */}
      <VideoCallLauncherDialog open={webcamDialogOpen} onClose={handleCloseWebcamDialog} authToken={token} />
      <SharedAdminDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} onVideocallClick={handleOpenWebcamDialog} />
      <main className={classes.content} style={{ background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        {/* <div className={classes.appBarSpacer} /> */}
        <Grid maxWidth="100%" className={classes.container} >
            <Grid item xs={12} >
              <Paper className={classes.tabs}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  classes={{ root: classes.tabsControlRoot, indicator: classes.tabIndicator }}
                >
                  <Tab label="Clinic" className={classes.tab} />
                  <Tab label="Settings" className={classes.tab} />
                  <Tab label="Security" className={classes.tab} />
                  <Tab label="Subscription" className={classes.tab} />
                </Tabs>
              </Paper>
              {tabValue === 0 && <ClinicDetails />}
              {tabValue === 1 && <ClinicSettings />}
              {tabValue === 2 && <ClinicSecurity />}
              {tabValue === 3 && <ClinicSubscription_Settings />}
            </Grid>
          <Box pt={2}>
            <Copyright />
          </Box>
        </Grid>
        {/* Chat System */}
        <ChatSystemContainer />
      </main>
    </div>
  );
}
